<template>
    <div>
        <invite-code-header page-name="招待コード"></invite-code-header>
        <div class="container">
            <div class="card card-body">
                <div class="row justify-content-center">
                    <div class="col-md-4 py-4 text-center">
                        <button class="btn btn-outline-primary btn-block mb-3" @click="openCompany">会社選択</button>

                        <div v-if="groupName" class="text-muted">
                            <div>({{groupName}})</div>
                            <div>{{companyName}}</div>
                        </div>
                        <div v-else class="text-muted">未設定</div>
                        <div class="pt-3">
                            <input v-model="salesName" type="search" class="form-control" spellcheck="false" placeholder="営業氏名">
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-4 py-4 text-center">
                        <button class="btn btn-primary btn-block mb-3" :disabled="groupName == ''" @click="makeUrl">招待URL作成</button>
                        <div v-if="getInviteInfo">
                            <div class="card card-body p-2 mb-3">
                                <small>
                                    {{getInviteInfo.invite_url}}
                                </small>
                            </div>
                            <button type="button" class="btn btn-primary btn-block" 
                                v-clipboard:copy="getInviteInfo.invite_url"
                                v-clipboard:success="copySuccess"
                                v-clipboard:error="copyError"
                            >
                                <i class="far fa-copy"></i>&nbsp;
                                URLをコピーする
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 会社選択 -->
        <select-company ref="selectCompany" :list="getCompanys"></select-company>

        <modal-info-msg ref="msg" :msg="msg" :lev="lev"></modal-info-msg>

    </div>
</template>

<script>
import InviteCodeHeader from 'pages/commons/header/Header'
import SelectCompany from 'pages/commons/modal/selectCompany/SelectCompany'
import ModalInfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'


import {mapGetters} from 'vuex'

export default {
    components: {
        InviteCodeHeader,
        SelectCompany,
        ModalInfoMsg
    },
    mounted () {
        this.resetUrl()
        this.loadCompanys()
    },
    data () {
        return {
            msg: "",
            lev: 0,
            groupName:'',
            companyName:'',
            salesName:''
        }
    },
    watch: {
        groupName () {
            this.resetUrl()
        },
        getCompanysLoadStatus () {
            if (this.getCompanysLoadStatus == 1) {
                this.$store.dispatch('startProgress')
            }
            if (this.getCompanysLoadStatus == 2) {
                this.$store.dispatch('doneProgress')
            }
            if (this.getCompanysLoadStatus == 3) {
                this.$store.dispatch('doneProgress')
            }
        },
        getInviteInfoLoadStatus () {
            if (this.getInviteInfoLoadStatus == 1) {
                this.$store.dispatch('startProgress')
            }

            if (this.getInviteInfoLoadStatus == 2) {
                this.$store.dispatch('doneProgress')
            }

            if (this.getInviteInfoLoadStatus == 3) {
                this.$store.dispatch('doneProgress')
            }
        }
    },
    computed: {
        ...mapGetters(['getCompanys'
                    ,'getCompanysLoadStatus'
                    ,'getInviteInfo'
                    ,'getInviteInfoLoadStatus'
        ])
    },
    methods: {
        loadCompanys () {
            this.$store.dispatch('loadCompanys')
        },
        openCompany () {
            this.$refs.selectCompany.openThis({name:'salesInvite', salesOpt:true})
        },
        salesInviteCompanySet (item) {
            this.groupName = item.user_group
            this.companyName = item.name
        },
        makeUrl() {
            this.$store.dispatch('loadInviteInfo', {
                type: '3', //m-s
                group: this.groupName + '@' + this.salesName,
            })
        },
        resetUrl () {
            this.$store.dispatch('resetInviteInfo')
        },
        copySuccess () {
            this.openMsg("URLをクリップボードへコピーしました。")
        },
        copyError () {
            this.openMsg("URLのコピーに失敗しました。再度試してください。", 1)
        },
        openMsg (msg, lev=0) {
            this.msg = msg
            this.lev = lev
            this.$refs.msg.openThis()
        }
    }
}
</script>

<style></style>
